import { Suspense, lazy } from 'react';
import { Routes, Route } from 'react-router-dom';
import { Layout } from '@/components/layout/Layout';
import { PageLoader } from '@/components/ui/PageLoader';

const Home = lazy(() => import('@/pages/Home').then((m) => ({ default: m.Home })));
const ServicesHub = lazy(() =>
  import('@/pages/ServicesHub').then((m) => ({ default: m.ServicesHub })),
);
const ServiceDetail = lazy(() =>
  import('@/pages/ServiceDetail').then((m) => ({ default: m.ServiceDetail })),
);
const ProductsHub = lazy(() =>
  import('@/pages/ProductsHub').then((m) => ({ default: m.ProductsHub })),
);
const ProductDetail = lazy(() =>
  import('@/pages/ProductDetail').then((m) => ({ default: m.ProductDetail })),
);
const About = lazy(() => import('@/pages/About').then((m) => ({ default: m.About })));
const Contact = lazy(() => import('@/pages/Contact').then((m) => ({ default: m.Contact })));
const NotFound = lazy(() => import('@/pages/NotFound').then((m) => ({ default: m.NotFound })));

export function App() {
  return (
    <Suspense fallback={<PageLoader />}>
      <Routes>
        <Route element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="services" element={<ServicesHub />} />
          <Route path="services/:slug" element={<ServiceDetail />} />
          <Route path="products" element={<ProductsHub />} />
          <Route path="products/:slug" element={<ProductDetail />} />
          <Route path="about" element={<About />} />
          <Route path="contact" element={<Contact />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </Suspense>
  );
}
